/**
 * Thông báo nhanh góc trên bên phải (theo mẫu): biểu tượng, nội dung, thanh thời gian chạy
 * và tự ẩn sau `THOI_GIAN_MS`. Gọi `hienThongBaoNhanh(...)` từ bất kỳ đâu; `KhungThongBaoNhanh`
 * gắn một lần trong khung trang.
 */
import { useEffect, useState, type ReactNode } from 'react';

export const THOI_GIAN_MS = 3000;

type LoaiThongBao = 'thanh-cong' | 'loi';
interface MucThongBao {
  id: number;
  noiDung: string;
  loai: LoaiThongBao;
}

let dem = 0;
const nguoiNghe = new Set<(m: MucThongBao) => void>();

export function hienThongBaoNhanh(noiDung: string, loai: LoaiThongBao = 'thanh-cong'): void {
  dem += 1;
  const muc = { id: dem, noiDung, loai };
  nguoiNghe.forEach((f) => f(muc));
}

export function KhungThongBaoNhanh(): ReactNode {
  const [ds, datDs] = useState<MucThongBao[]>([]);
  useEffect(() => {
    const nhan = (m: MucThongBao): void => {
      datDs((cu) => [...cu, m]);
      setTimeout(() => datDs((cu) => cu.filter((x) => x.id !== m.id)), THOI_GIAN_MS);
    };
    nguoiNghe.add(nhan);
    return () => {
      nguoiNghe.delete(nhan);
    };
  }, []);
  if (ds.length === 0) return null;
  return (
    <div className="tbn" aria-live="polite">
      {ds.map((m) => (
        <div key={m.id} className={`tbn__muc tbn__muc--${m.loai}`} role="status" data-vung="thong-bao-nhanh">
          <span className="tbn__dau" aria-hidden="true">
            {m.loai === 'thanh-cong' ? '✓' : '!'}
          </span>
          <span className="tbn__noi-dung">{m.noiDung}</span>
          <span className="tbn__thanh" style={{ animationDuration: `${THOI_GIAN_MS}ms` }} />
        </div>
      ))}
    </div>
  );
}
